// extracted by mini-css-extract-plugin
module.exports = {"item":"Style_item__a76Bj","title":"Style_title__3qa3k","detail":"Style_detail__3XrLw"};